import { Circle, Fill, Stroke, Style, Icon } from 'ol/style.js'
import { MultiPoint } from 'ol/geom'
import { getElementsArray, getElement } from '@Utils/Elements.js'
import { getIconUrl, getDirectionalIconList, renderIcons } from '@Utils/Icons.js'
import { getCSplineGeometry } from '@Utils/FeatureUtils.js'


let penaltyAreaTypes = ["noplayzone", "red", "yellow", "outofbounds", "areaunderrepair"]
let selectionColor = 'yellow'
let geometryCache = {}
let opacityFill = '30'
let opacityStroke = '80'
export function getGeometryCache(feature, type) {
	let id = feature.ol_uid + "-" + type
	let el = getElement(feature.get('elementName'))
	let rounded = feature.get('rounded') ?? el.defaultValues.rounded
	if (feature.get('clearCache')) {
		delete geometryCache[id]
		feature.unset('clearCache')
	}

	if (!geometryCache[id] || geometryCache[id].revision !== feature.revision_) {
		let geometry
		if (type === 'Polygon' || type === 'LineString') {
			if (rounded) {
				geometry = getCSplineGeometry(feature)
			} else {
				geometry = feature.getGeometry()
			}
		} else if (type == 'MultiPoint') {
			let type = feature.getGeometry().getType()
			if (type === 'Polygon') {
				geometry = new MultiPoint(feature.getGeometry().getCoordinates()[0])
			} else if (type === 'LineString') {
				geometry = new MultiPoint(feature.getGeometry().getCoordinates())
			} else {
				geometry = feature.getGeometry()
			}
		}
		geometryCache[id] = {
			revision: feature.revision_,
			geometry: geometry
		}
	}
	return geometryCache[id].geometry
}
export function createPenaltyStyle(element, type, noPlayZone, selected, styles = []) {
	const penalty_red = `hsla(6, 95%,60%, ${selected ? 1 : 0.5})`
	const penalty_yellow = `hsla(47, 86%,60%, ${selected ? 1 : 0.5})`
	const penalty_white = `hsla(0, 0%, 100%, ${selected ? 1 : 0.5})`
	const penalty_blue = `hsla(210, 95%,60%, ${selected ? 1 : 0.5})`
	const penalty_green = `hsla(94, 95%,60%, ${selected ? 1 : 0.5})`
	let colors = []
	switch (type) {
		case "red":
			colors = [penalty_red]
			if (noPlayZone === true) {
				colors.push(penalty_green)
			}
			break
		case "yellow":
			colors = [penalty_yellow]
			break
		case "outofbounds":
			colors = [penalty_white]
			break
		case "areaunderrepair":
			colors = [penalty_blue]
			if (noPlayZone === true) {
				colors.push(penalty_white)
			}
			break
	}
	for (let color of colors) {
		let size = 7
		let num = colors.indexOf(color) + 1
		styles.push(new Style({
			stroke: new Stroke({
				color: color,
				lineDash: [0, num * size * 2],
				width: size
			}),
			geometry: function (feature) {
				return getGeometryCache(feature, element.tooltype)
			}
		}))
	}
	return styles
}

function createIconStyle(element, selected, resolution, icon, directional, directionalIcon) {
	let styles = []
	if (directional) {
		styles.push(new Style({
			image: new Icon({
				anchor: [element.mapIconOffsetX ?? 0.5, element.mapIconOffsetY ?? 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				rotateWithView: true,
				src: getIconUrl(directionalIcon ?? "DirectionalChevronRounded"),
				opacity: selected ? 1 : 0.5
			})
		}))
	}


	if(getIconUrl(icon ?? element.icon)) {
		let s = new Style({
			image: new Icon({
				anchor: [element.mapIconOffsetX ?? 0.5, element.mapIconOffsetY ?? 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				rotateWithView: true,
				src: getIconUrl(icon ?? element.icon ?? "Unknown"),
				opacity: selected ? 1 : 0.5
			})
		})
		s.rotateWithView = true
		styles.push(s)
	} else {
		console.error("Missing reference to icon: " + icon, element.icon, element.name)
	}

	return styles
}
function createFocusStyle(element, selected, resolution) {
	let styles = [
		new Style({
			stroke: new Stroke({
				color: selected ? selectionColor : element.color,
				lineDash: [16, 4],
				width: selected ? 1 : 2,
			}),
			geometry: function (feature) {
				return getGeometryCache(feature, 'Polygon')
			}
		})
	]
	if (!selected) {
		return styles
	}
	styles.push(
		new Style({
			geometry: function (feature) {
				return getGeometryCache(feature, 'MultiPoint')
			},
			image: new Circle({
				radius: 4,
				fill: new Fill({
					color: selectionColor
				})
			})
		})
	)
	styles.push(
		new Style({
			stroke: new Stroke({
				color: 'rgba(255,255,255,0.5)',
				width: 1
			}),
			fill: new Fill({
				color: 'rgba(255,255,0,0.2)'
			}),
			geometry: function (feature) {
				return feature.getGeometry()
				//return fromExtent(feature.getGeometry().getExtent())
			}
		})
	)
	return styles
}
function createRectangleStyle(element, selected, resolution) {
	let styles = []
	styles.push(new Style({
		fill: new Fill({
			//color: selected ? 'rgba(255,255,0,0.5)' : element.color + opacityFill
			color: element.color + opacityFill
		}),
		stroke: new Stroke({
			color: selected ? 'rgba(255,255,255,0)' : 'rgba(255,255,255, 0.5)',
			width: selected ? 0 : 1
		}),
		geometry: function (feature) {
			return getGeometryCache(feature, 'Polygon')
		}
	}))
	if (!selected) {
		return styles
	}
	styles.push(
		new Style({
			geometry: function (feature) {
				return getGeometryCache(feature, 'MultiPoint')
			},
			image: new Circle({
				radius: 3,
				fill: new Fill({
					color: element.color + opacityFill
				}),
				stroke: new Stroke({
					color: 'rgba(255,255,255,0.5)',
					width: 2
				})
			})
		})
	)
	styles.push(
		new Style({
			stroke: new Stroke({
				color: 'rgba(255,255,255,0.5)',
				width: 1
			}),
			geometry: function (feature) {
				return feature.getGeometry()
			}
		})
	)
	return styles
}
function createPolygonStyle(element, selected, resolution) {
	let styles = []
	styles.push(new Style({
		fill: new Fill({
			//color: selected ? 'rgba(255,255,0,0.5)' : element.color + opacityFill
			color: element.color + opacityFill
		}),
		stroke: new Stroke({
			color: selected ? selectionColor : 'rgba(255,255,255, 0.5)',
			width: selected ? 0 : 1
		}),
		geometry: function (feature) {
			return getGeometryCache(feature, 'Polygon')
		}
	}))
	if (!selected) {
		return styles
	}
	styles.push(
		new Style({
			geometry: function (feature) {
				return getGeometryCache(feature, 'MultiPoint')
			},
			image: new Circle({
				radius: 4,
				fill: new Fill({
					color: selectionColor
				})
			})
		})
	)
	styles.push(
		new Style({
			stroke: new Stroke({
				color: 'rgba(255,255,255,0.5)',
				width: 1
			}),
			geometry: function (feature) {
				return feature.getGeometry()
			}
		})
	)
	return styles
}
function createLineStringStyle(element, selected, resolution) {
	let styles = []
	styles.push(
		new Style({
			geometry: function (feature) {
				return getGeometryCache(feature, 'MultiPoint')
			},
			image: new Circle({
				radius: 4,
				fill: new Fill({
					color: 'rgba(255,255,255,0.5)'
				})
			})
		})
	)
	styles.push(
		new Style({
			stroke: new Stroke({
				lineCap: 'butt',
				color: 'rgba(255,255,255,0.5)',
				width: 1
			}),
			geometry: function (feature) {
				return feature.getGeometry()
			}
		})
	)
	if (!selected) {
		return styles
	}
	styles.push(
		new Style({
			geometry: function (feature) {
				return getGeometryCache(feature, 'MultiPoint')
			},
			image: new Circle({
				radius: 4,
				fill: new Fill({
					color: selectionColor
				})
			})
		})
	)
	styles.push(
		new Style({
			stroke: new Stroke({
				color: selectionColor,
				lineCap: 'butt',
				width: 1
			}),
			geometry: function (feature) {
				return getGeometryCache(feature, 'LineString')
			}
		})
	)
	return styles
}
export function createElementStyles(selected, resolution) {
	let elementStyles = {}
	for (let e of getElementsArray()) {
		if (e.editStyle == 'icon') {
			let icons = renderIcons
			let directionalIcons = getDirectionalIconList()
			for (let icon in icons) {
				elementStyles[e.name + "-" + icon] = createIconStyle(e, selected, resolution, icon)
				for (let directionalIcon of directionalIcons) {
					elementStyles[e.name + "-" + icon + "-directional-" + directionalIcon] = createIconStyle(e, selected, resolution, icon, true, directionalIcon)
				}
			}
			elementStyles[e.name] = createIconStyle(e, selected, resolution)
		} else if (e.tooltype == 'Polygon') {
			if (e.name == 'focus' || e.name == 'greenfocus') {
				elementStyles[e.name] = createFocusStyle(e, selected, resolution)
			} else {
				elementStyles[e.name] = createPolygonStyle(e, selected, resolution)
			}
		} else if (e.tooltype == 'Rectangle') {
			elementStyles[e.name] = createRectangleStyle(e, selected, resolution)
		}
		if (e.tooltype == 'Polygon') {
			for (let type of penaltyAreaTypes) {
				let styles = createPolygonStyle(e, selected, resolution)
				if (!selected) {
					styles = createPenaltyStyle(e, type, false, selected, styles)
				}
				elementStyles[e.name + "-" + type] = styles
				styles = createPolygonStyle(e, selected, resolution)
				if (!selected) {
					styles = createPolygonStyle(e, selected, resolution)
					elementStyles[e.name + "-" + type] = createPenaltyStyle(e, type, false, selected, styles)
					styles = createPolygonStyle(e, selected, resolution)
					elementStyles[e.name + "-" + type + "-noplayzone"] = createPenaltyStyle(e, type, true, selected, styles)
				} else {
					styles = createPolygonStyle(e, selected, resolution)
					elementStyles[e.name + "-" + type + "-noplayzone"] = styles
				}
			}
		}
		if (e.tooltype == 'LineString') {
			let styles = []

			for (let type of penaltyAreaTypes) {
				if (selected) {
					styles = createLineStringStyle(e, selected, resolution)
				} else {
					styles = createPenaltyStyle(e, type, false, selected)
				}
				elementStyles[e.name + "-" + type] = styles
				if (selected) {
					elementStyles[e.name + "-" + type + "-noplayzone"] = elementStyles[e.name + "-" + type] = createLineStringStyle(e, selected, resolution)
					
				} else {
					styles = createPenaltyStyle(e, type, false, selected)
					elementStyles[e.name + "-" + type + "-noplayzone"] = createPenaltyStyle(e, type, true, selected)
				}
			}
		}
	}
	return elementStyles
}